<template>
	<v-container>
		<div class="base-page">
			<logo-with-title :title="$t('login')" />
			<edu-login-button />
			<login-form :error="errorBag" :loading="loading" @submit="handleSubmit" @register="gotoRegister"></login-form>
			<lang-select />
		</div>
	</v-container>
</template>

<script>
import LangSelect from "../../components/LangSelect.vue";
import EduLoginButton from "@/components/EduLoginButton";
import LoginForm from "./LoginForm";
import LogoWithTitle from "@/components/LogoWithTitle";

export default {
	name: "PassportLogin",
	components: { LangSelect, EduLoginButton, LoginForm, LogoWithTitle },
	props: {
		admin: {
			type: Boolean,
		},
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: "",
		},
		loading: false,

	}),
	computed: {
		csrf() {
			return document.querySelector("meta[name=csrf-token]").getAttribute("content");
		},
		errorBag() {
			const errorsBag = window.errorsBag;
			if (Array.isArray(errorsBag) && errorsBag.length > 0)
				return errorsBag[0];
			if (!!errorsBag && typeof errorsBag === "object" && Object.keys(errorsBag).length > 0)
				return Object.values(errorsBag)[0][0];
			return '';

		},
		showErrors() {
			return (Object.values(this.errorBag).length > 0 || (this.errorBag && this.errorBag.length > 0));
		},
	},
	methods: {
		gotoRegister() {
			window.errorsBag = [];
			this.$router.push({ path: "/register" });
		},

		eduLogin() {
			let redirect = "/login/saml2";
			if (this.$route.query.p) {
				sessionStorage.setItem("activeProject", this.$route.query.p);
				redirect += `?p=${this.$route.query.p}`;
			}
			window.location = redirect;
		},
		handleSubmit(params) {

			this.loading = true;
			// Submit the form synchronously
			params.event.target.submit();

		}
	},
};
</script>

<style lang="scss" scoped>


.project-name {
	&--col {
		padding: 0;

		div {
			height: 40px;
			width: 220px;
			background: #4595cc 0 0 no-repeat padding-box;
			border-radius: 0 0 20px 20px;
			opacity: 1;
		}
	}
}

</style>
